import {EntityModel} from "@fedeltapointofsale/data-client";
import {PlgData} from "./plg.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PlgEntityModel extends EntityModel<PlgData> {
    constructor(injector: Injector) {
        super(injector, PlgData);
    }

    override getResourceName(): string {
        return "plg";
    }

    override getResource(): string {
        return "composite-option-group";
    }
}
